/**
 * expression template parser
 */
import { warn } from '@ali/re-utils';
import { hasOwn } from './utils';

const R_D = /\\/g;
const R_Q = /'/g;
const R_M = /[\t\b\f\r\n]/g;
const R_EXPR = /\${.+}/;
const T_OPEN = '${';
const T_CLOSE = '}';
const CACHE = {};

const tokenReg = /([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z0-9_$]|\.)+/g;
const quotReg = /[^\\]'.*?[^\\]'/g;
const doubleQuotReg = /[^\\]".*?[^\\]"/g;

function r(str) {
  return str.replace(R_D, '\\\\').replace(R_Q, "\\'").replace(R_M, ' ');
}

function rc(str) {
  return str.replace(R_M, ' ');
}

function quote(str) {
  return `'${r(str)}'`;
}

function expr(str, temp) {
  return `
  (function(){
    try{
      return(${rc(str)});
    }catch(e){
      if(console){
        console.warn(e.message, "in ${temp.replace(/"/g, '\\"')}");
      }
      return null;
    }
  })()`;
}

function findCloseTag(head) {
  let startCount = 1;
  let inQuote;
  for (let i = 0; i < head.length; i++) {
    const char = head[i];
    if (!inQuote) {
      if (char === '{') {
        startCount++;
      }
      if (char === '}') {
        startCount--;
        if (!startCount) {
          return i;
        }
      }
    }
    if (char === '\'' || char === '"' || char === '`') {
      if (inQuote === char) {
        inQuote = '';
      } else if (!inQuote) {
        inQuote = char;
      }
    }
  }
  return undefined;
}

function compileBody(temp) {
  const template = temp.split(T_OPEN);

  let head = template.shift();
  const body = [];
  if (head) {
    body.push(`__O.push(${quote(head)});`);
  }

  let tails;
  let token;
  let hasExpr = false;
  while (template[0] != null) {
    ([head] = template);
    // 匹配中间的括号
    const closeIndex = findCloseTag(head);
    if (typeof closeIndex === 'number') {
      tails = [head.slice(0, closeIndex), head.slice(closeIndex + 1)];
    } else {
      tails = head.split(T_CLOSE);
    }
    hasExpr = false;
    if (tails.length > 1) {
      token = tails[0].trim();
      token.replace(quotReg, '') // 过滤字符串
        .replace(doubleQuotReg, '') // 过滤字符串
        .match(tokenReg).filter(k => !(k[0] >= '0' && k[0] <= '9')); // 添加表达式用到的字段
      if (token) {
        hasExpr = true;
        body.push(`__O.push(${expr(token, temp)});`);
        tails.shift();
      }
    }
    if (hasExpr) {
      tails = tails.join(T_CLOSE);
      if (tails) {
        body.push(`__O.push(${quote(tails)});`);
      }
    } else {
      body.push(`__O.push(${quote(`$\{${head}`)});`);
    }
    template.shift();
  }

  let ret = 'return __O.join("")';
  if (hasExpr && body.length === 1) {
    ret = 'return __O[0]';
  }

  return `var __O=[];with(__I){${body.join('')}} ${ret}`;
}

function getRenderer(template) {
  if (!hasOwn(CACHE, template)) {
    try {
      const ut = {};
      const renderer = new Function('__I', compileBody(template, ut));
      CACHE[template] = { renderer, ut };
    } catch (e) {
      warn(`compile expression error: ${template}`, e.message);
      return false;
    }
  }
  return CACHE[template].renderer;
}

function test(template) {
  return R_EXPR.test(template);
}

function parser(template, data) {
  if (!test(template)) {
    return template;
  }

  const renderer = getRenderer(template);

  if (!renderer) {
    return template;
  }

  try {
    return renderer(data);
  } catch (e) {
    warn(e.message, renderer);
    return template;
  }
}

parser.getRenderer = getRenderer;
parser.compileBody = compileBody;
parser.test = test;

export default parser;
